(function () {
    'use strict';

    const selectors$E = {
        collectionSidebar: '[data-collection-sidebar]',
        collectionSidebarSlideOut: '[data-collection-sidebar-slide-out]',
        collectionSidebarCloseButton: '[data-collection-sidebar-close]',
        groupTagsButton: '[data-aria-toggle]',
        animation: '[data-animation]',
    };

    const classes$v = {
        animated: 'drawer--animated',
        hiding: 'is-hiding',
        expanded: 'expanded',
        noMobileAnimation: 'no-mobile-animation',
        focused: 'is-focused',
    };

    const selectors$G = {
        section: '[data-section-type]',
        collectionSidebar: '[data-collection-sidebar]',
        collectionSidebarSlideOut: '[data-collection-sidebar-slide-out]',
        collectionSidebarCloseButton: '[data-collection-sidebar-close]',
        form: '[data-collection-filters-form]',
        input: 'input',
        select: 'select',
        label: 'label',
        textarea: 'textarea',
        priceMin: '[data-field-price-min]',
        priceMax: '[data-field-price-max]',
        priceMinValue: 'data-field-price-min',
        priceMaxValue: 'data-field-price-max',
        rangeMin: '[data-se-min-value]',
        rangeMax: '[data-se-max-value]',
        rangeMinValue: 'data-se-min-value',
        rangeMaxValue: 'data-se-max-value',
        rangeMinDefault: 'data-se-min',
        rangeMaxDefault: 'data-se-max',
        product: '[data-grid-item]',
        showMore: '[data-show-more]',
        linkHidden: '[data-link-hidden]',
        collectionNav: '[data-collection-nav]',
        productsContainer: '[data-products-grid]',
        activeFilters: '[data-active-filters]',
        activeFiltersCount: 'data-active-filters-count',
        filterUpdateUrlButton: '[data-filter-update-url]',
        dataSort: '[data-sort-enabled]',
        sortLinks: '[data-sort-link]',
        sortValue: 'data-value',
        sortButton: '[data-popout-toggle]',
        sortButtonText: '[data-sort-button-text]',
        resultsCount: '[data-results-count]',
    };

    const classes$x = {
        hidden: 'hidden',
        focused: 'is-focused',
        loading: 'is-loading',
        active: 'is-active',
    };

    class Collection {
        constructor(section) {
            this.container = section.container;
            this.collectionSidebar = this.container.querySelector(selectors$E.collectionSidebar);
            this.groupTagsButton = this.container.querySelector(selectors$E.groupTagsButton);
            this.groupTagsButtonClickEvent = (evt) => this.groupTagsButtonClick(evt);
            this.sidebarResizeEvent = () => this.toggleSidebarSlider();
            this.collectionSidebarCloseEvent = (evt) => this.collectionSidebarClose(evt);

            this.init();
        }

        init() {
            if (this.groupTagsButton !== null) {
                document.addEventListener('theme:resize:width', this.sidebarResizeEvent);

                this.groupTagsButton.addEventListener('click', this.groupTagsButtonClickEvent);

                // Prevent filters closing animation on page load
                if (this.collectionSidebar) {
                    setTimeout(() => {
                        this.collectionSidebar.classList.remove(classes$v.noMobileAnimation);
                    }, 1000);
                }

                const toggleFiltersObserver = new MutationObserver((mutationList) => {
                    for (const mutation of mutationList) {
                        if (mutation.type === 'attributes') {
                            const expanded = mutation.target.getAttribute('aria-expanded') == 'true';

                            if (expanded) {
                                this.showSidebarCallback();
                            }
                        }
                    }
                });

                toggleFiltersObserver.observe(this.groupTagsButton, {
                    attributes: true,
                    childList: false,
                    subtree: false,
                });
            }

            // Hide filters sidebar on ESC keypress
            this.container.addEventListener(
                'keyup',
                function (evt) {
                    if (evt.code !== 'Escape') {
                        return;
                    }
                    this.hideSidebar();
                }.bind(this)
            );

            if (this.collectionSidebar) {
                this.collectionSidebar.addEventListener('transitionend', () => {
                    if (!this.collectionSidebar.classList.contains(classes$v.expanded)) {
                        this.collectionSidebar.classList.remove(classes$v.animated);
                    }
                });

                this.toggleSidebarSlider();

                this.container.addEventListener('theme:filter:close', this.collectionSidebarCloseEvent);
            }
        }

        showSidebarCallback() {
            const collectionSidebarSlideOut = this.container.querySelector(selectors$E.collectionSidebarSlideOut);
            const isScrollLocked = document.documentElement.hasAttribute('data-scroll-locked');

            const isMobileView = window.theme.utils.isMobile();
            this.collectionSidebar.classList.add(classes$v.animated);

            if (collectionSidebarSlideOut === null) {
                if (!isMobileView && isScrollLocked) {
                    window.theme.a11y.removeTrapFocus();
                    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
                }
            }

            if (isMobileView || collectionSidebarSlideOut !== null) {
                if (collectionSidebarSlideOut) {
                    window.theme.a11y.trapFocus(this.collectionSidebar, {
                        elementToFocus: this.collectionSidebar.querySelector(selectors$E.collectionSidebarCloseButton),
                    });
                }
                document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
            }
        }

        hideSidebar() {
            const collectionSidebarSlideOut = this.container.querySelector(selectors$E.collectionSidebarSlideOut);
            const isScrollLocked = document.documentElement.hasAttribute('data-scroll-locked');

            this.groupTagsButton.setAttribute('aria-expanded', 'false');
            this.collectionSidebar.classList.remove(classes$v.expanded);

            if (collectionSidebarSlideOut) {
                window.theme.a11y.removeTrapFocus();
            }

            if (isScrollLocked) {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
            }
        }

        toggleSidebarSlider() {
            if (window.theme.utils.isMobile()) {
                this.hideSidebar();
            } else if (this.collectionSidebar.classList.contains(classes$v.expanded)) {
                this.showSidebarCallback();
            }
        }

        collectionSidebarClose(evt) {
            evt.preventDefault();
            this.hideSidebar();
            if (document.body.classList.contains(classes$v.focused) && this.groupTagsButton) {
                this.groupTagsButton.focus();
            }
        }

        groupTagsButtonClick() {
            const isScrollLocked = document.documentElement.hasAttribute('data-scroll-locked');

            if (isScrollLocked) {
                document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
            }
        }

        onUnload() {
            if (this.groupTagsButton !== null) {
                document.removeEventListener('theme:resize:width', this.sidebarResizeEvent);
                this.groupTagsButton.removeEventListener('click', this.groupTagsButtonClickEvent);
            }

            if (this.collectionSidebar) {
                this.container.removeEventListener('theme:filter:close', this.collectionSidebarCloseEvent);
            }
        }
    }

    class CollectionFiltersForm extends HTMLElement {
        constructor() {
            super();

            this.container = this.closest(selectors$G.section);
            this.collectionSidebar = this.container.querySelector(selectors$G.collectionSidebar);
            this.collectionSidebarSlideOut = this.container.querySelector(selectors$G.collectionSidebarSlideOut);
            this.form = this.querySelector(selectors$G.form);
            this.productsContainer = this.container.querySelector(selectors$G.productsContainer);
            this.collectionNav = this.container.querySelector(selectors$G.collectionNav);
            this.sort = this.container.querySelector(selectors$G.dataSort);
            this.sortButton = this.container.querySelector(selectors$G.sortButton);
            this.sortLinks = this.container.querySelectorAll(selectors$G.sortLinks);
            this.filterUrlButtons = this.container.querySelectorAll(selectors$G.filterUpdateUrlButton);
            this.collectionSidebarCloseButtons = this.container.querySelectorAll(selectors$G.collectionSidebarCloseButton);
            this.showMoreOptions = this.querySelectorAll(selectors$G.showMore);

            this.updatePriceEvent = window.theme.utils.debounce((e) => this.updatePrice(e), 500);
            this.updateRangeEvent = (e) => this.updateRange(e);
            this.showMoreEvent = (e) => this.showMore(e);
            this.onSortButtonClickEvent = (e) => this.onSortButtonClick(e);
            this.submitFormEvent = (e) => this.submitForm(e);
            this.collectionSidebarCloseEvent = (e) => this.collectionSidebarClose(e);
            this.filterUpdateFromUrlEvent = (e) => this.filterUpdateFromUrl(e);
        }

        connectedCallback() {
            if (this.sort && this.sortLinks.length) {
                this.sortLinks.forEach((link) => {
                    link.addEventListener('click', this.onSortButtonClickEvent);
                });
            }

            if (this.collectionSidebar && this.form) {
                this.collectionSidebar.addEventListener('input', this.updatePriceEvent);
                this.collectionSidebar.addEventListener('theme:range:update', this.updateRangeEvent);
            }

            if (this.showMoreOptions.length) {
                this.showMoreOptions.forEach((element) => {
                    element.addEventListener('click', this.showMoreEvent);
                });
            }

            if (this.collectionSidebar || this.sort) {
                window.addEventListener('popstate', this.submitFormEvent);
            }

            if (this.filterUrlButtons.length) {
                this.filterUrlButtons.forEach((filterUrlButton) => {
                    filterUrlButton.addEventListener('click', this.filterUpdateFromUrlEvent);
                });
            }

            if (this.collectionSidebarCloseButtons.length) {
                this.collectionSidebarCloseButtons.forEach((button) => {
                    button.addEventListener('click', this.collectionSidebarCloseEvent);
                });
            }
        }

        collectionSidebarClose(e) {
            e.preventDefault();
            this.container.dispatchEvent(new CustomEvent('theme:filter:close', { bubbles: false }));
        }

        onSortButtonClick(e) {
            e.preventDefault();

            if (this.sortButton) {
                this.sortButton.dispatchEvent(new Event('click'));
            }

            this.sortActions(e, e.currentTarget);
        }

        sortActions(e, link, submitForm = true) {
            const sortButtonText = this.sort.querySelector(selectors$G.sortButtonText);
            const sortActive = this.sort.querySelector(`.${classes$x.active}`);

            if (sortButtonText) {
                const linkText = link ? link.textContent.trim() : '';
                sortButtonText.textContent = linkText;
            }

            if (sortActive) {
                sortActive.classList.remove(classes$x.active);
            }

            this.sort.classList.toggle(classes$x.active, link);

            if (link) {
                link.parentElement.classList.add(classes$x.active);

                if (submitForm) {
                    this.submitForm(e);
                }
            }
        }

        onSortCheck(e) {
            let link = null;
            if (window.location.search.includes('sort_by')) {
                const url = new window.URL(window.location.href);
                const urlParams = url.searchParams;

                for (const [key, val] of urlParams.entries()) {
                    const linkSort = this.sort.querySelector(`[${selectors$G.sortValue}="${val}"]`);
                    if (key.includes('sort_by') && linkSort) {
                        link = linkSort;
                        break;
                    }
                }
            }

            this.sortActions(e, link, false);
        }

        showMore(e) {
            e.preventDefault();
            const target = e.target.matches(selectors$G.showMore) ? e.target : e.target.closest(selectors$G.showMore);

            target.parentElement.classList.add(classes$x.hidden);
            target.parentElement.previousElementSibling.querySelectorAll(selectors$G.linkHidden).forEach((link, index) => {
                link.classList.remove(classes$x.hidden);
                const input = link.querySelector(selectors$G.input);
                if (index === 0 && document.body.classList.contains(classes$x.focused) && input) {
                    if (this.collectionSidebarSlideOut || window.theme.utils.isMobile()) {
                        window.theme.a11y.removeTrapFocus();
                        window.theme.a11y.trapFocus(this.collectionSidebar, {
                            elementToFocus: input
                        });
                    } else {
                        input.focus();
                    }
                }
            });
        }

        updatePrice(e) {
            const type = e.type;
            const target = e.target;

            if (type === selectors$G.input || type === selectors$G.select || type === selectors$G.label || type === selectors$G.textarea) {
                if (this.form && typeof this.form.submit === 'function') {
                    const priceMin = this.form.querySelector(selectors$G.priceMin);
                    const priceMax = this.form.querySelector(selectors$G.priceMax);
                    if (priceMin && priceMax) {
                        if (target.hasAttribute(selectors$G.priceMinValue) && !priceMax.value) {
                            priceMax.value = priceMax.placeholder;
                        } else if (target.hasAttribute(selectors$G.priceMaxValue) && !priceMin.value) {
                            priceMin.value = priceMin.placeholder;
                        }
                    }

                    this.submitForm(e);
                }
            }
        }

        updateRange(e) {
            if (this.form && typeof this.form.submit === 'function') {
                const rangeMin = this.form.querySelector(selectors$G.rangeMin);
                const rangeMax = this.form.querySelector(selectors$G.rangeMax);
                const priceMin = this.form.querySelector(selectors$G.priceMin);
                const priceMax = this.form.querySelector(selectors$G.priceMax);
                const checkElements = rangeMin && rangeMax && priceMin && priceMax;

                if (checkElements && rangeMin.hasAttribute(selectors$G.rangeMinValue) && rangeMax.hasAttribute(selectors$G.rangeMaxValue)) {
                    const priceMinValue = parseInt(priceMin.placeholder);
                    const priceMaxValue = parseInt(priceMax.placeholder);
                    const rangeMinValue = parseInt(rangeMin.getAttribute(selectors$G.rangeMinValue));
                    const rangeMaxValue = parseInt(rangeMax.getAttribute(selectors$G.rangeMaxValue));

                    if (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) {
                        priceMin.value = rangeMinValue;
                        priceMax.value = rangeMaxValue;

                        this.submitForm(e);
                    }
                }
            }
        }

        filterUpdateFromUrl(e) {
            e.preventDefault();
            this.submitForm(e, e.currentTarget.getAttribute('href'));
        }

        submitForm(e, replaceHref = '') {
            if (!e || (e && e.type !== 'popstate')) {
                if (replaceHref === '') {
                    const url = new window.URL(window.location.href);
                    let filterUrl = url.searchParams;
                    const filterUrlEntries = filterUrl;
                    const filterUrlParams = Object.fromEntries(filterUrlEntries);
                    const filterUrlRemoveString = filterUrl.toString();

                    if (filterUrlRemoveString.includes('filter.') || filterUrlRemoveString.includes('page=') || filterUrlRemoveString.includes('sort_by=')) {
                        for (const key in filterUrlParams) {
                            if (key.includes('filter.') || key === 'page' || key === 'sort_by') {
                                filterUrl.delete(key);
                            }
                        }
                    }

                    if (this.form) {
                        const formData = new FormData(this.form);
                        const formParams = new URLSearchParams(formData);
                        const rangeMin = this.form.querySelector(selectors$G.rangeMin);
                        const rangeMax = this.form.querySelector(selectors$G.rangeMax);
                        const rangeMinDefaultValue = rangeMin && rangeMin.hasAttribute(selectors$G.rangeMinDefault) ? rangeMin.getAttribute(selectors$G.rangeMinDefault) : '';
                        const rangeMaxDefaultValue = rangeMax && rangeMax.hasAttribute(selectors$G.rangeMaxDefault) ? rangeMax.getAttribute(selectors$G.rangeMaxDefault) : '';
                        let priceFilterDefaultCounter = 0;

                        for (let [key, val] of formParams.entries()) {
                            if ((key.includes('filter.') && val) || (key.includes('sort_by') && val)) {
                                filterUrl.append(key, val);

                                if ((val === rangeMinDefaultValue && key === 'filter.v.price.gte') || (val === rangeMaxDefaultValue && key === 'filter.v.price.lte')) {
                                    priceFilterDefaultCounter += 1;
                                }
                            }
                        }

                        if (priceFilterDefaultCounter === 2) {
                            filterUrl.delete('filter.v.price.gte');
                            filterUrl.delete('filter.v.price.lte');
                        }
                    }

                    const filterUrlString = filterUrl.toString();
                    const filterNewParams = filterUrlString ? `?${filterUrlString}` : location.pathname;
                    window.history.pushState(null, '', filterNewParams);
                } else {
                    window.history.pushState(null, '', replaceHref);
                }
            } else if (this.sort) {
                this.onSortCheck(e);
            }

            if (this.productsContainer) {
                this.productsContainer.classList.add(classes$x.loading);
                fetch(`${window.location.pathname}${window.location.search}`)
                    .then((response) => response.text())
                    .then((data) => {
                        const dataHtml = new DOMParser().parseFromString(data, 'text/html');

                        // Update results count on search page
                        const resultsCountContainer = this.container.querySelector(selectors$G.resultsCount);
                        if (resultsCountContainer) {
                            const newResultsCount = dataHtml.querySelector(selectors$G.resultsCount);
                            resultsCountContainer.innerHTML = newResultsCount.innerHTML;
                        }

                        this.productsContainer.innerHTML = dataHtml.querySelector(selectors$G.productsContainer).innerHTML;

                        if (this.collectionSidebar) {
                            this.collectionSidebar.innerHTML = dataHtml.querySelector(selectors$G.collectionSidebar).innerHTML;

                            const activeFiltersCountContainer = this.collectionSidebar.querySelector(`[${selectors$G.activeFiltersCount}]`);
                            const activeFiltersContainer = this.container.querySelectorAll(selectors$G.activeFilters);
                            if (activeFiltersCountContainer && activeFiltersContainer.length) {
                                const activeFiltersCount = parseInt(activeFiltersCountContainer.getAttribute(selectors$G.activeFiltersCount));

                                activeFiltersContainer.forEach((counter) => {
                                    counter.textContent = activeFiltersCount;
                                    counter.classList.toggle(classes$x.hidden, activeFiltersCount < 1);
                                });
                            }
                        }

                        if (this.collectionNav) {
                            window.scrollTo({
                              top: this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight,
                              behavior: 'smooth'
                            });
                        }

                        setTimeout(() => {
                            this.productsContainer.classList.remove(classes$x.loading);
                        }, 500);

                        const event = new CustomEvent('collection:filters:updated', {
                            detail: {
                                element: this.productsContainer // Passing the products container
                            }
                        });
                        document.dispatchEvent(event);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }

        disconnectedCallback() {
            if (this.collectionSidebar && this.form) {
                this.collectionSidebar.removeEventListener('input', this.updatePriceEvent);
                this.collectionSidebar.removeEventListener('theme:range:update', this.updateRangeEvent);
            }

            if (this.showMoreOptions.length) {
                this.showMoreOptions.forEach((element) => {
                    element.removeEventListener('click', this.showMoreEvent);
                });
            }

            if (this.sort && this.sortLinks.length) {
                this.sortLinks.forEach((link) => {
                    link.removeEventListener('click', this.onSortButtonClickEvent);
                });
            }

            if (this.collectionSidebar || this.sort) {
                window.removeEventListener('popstate', this.submitFormEvent);
            }

            if (this.filterUrlButtons.length) {
                this.filterUrlButtons.forEach((filterUrlButton) => {
                    filterUrlButton.removeEventListener('click', this.filterUpdateFromUrlEvent);
                });
            }

            if (this.collectionSidebarCloseButtons.length) {
                this.collectionSidebarCloseButtons.forEach((button) => {
                    button.removeEventListener('click', this.collectionSidebarCloseEvent);
                });
            }
        }
    }

    if (!customElements.get('collection-filters-form')) {
        customElements.define('collection-filters-form', CollectionFiltersForm);
    }

    let sections$i = {};

    const collectionSection = {
        onLoad() {
            sections$i[this.id] = new Collection(this);
        },
        onUnload() {
            sections$i[this.id].onUnload();
        },
    };

    window.theme.register('collection', [collectionSection]);
})(); 